import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { WithUserData } from '@grandvisionhq/my-account';
import { withUserToken } from '../../../../hoc/with-user-token.js';
import RescheduleAppointmentRootContainer from './RescheduleAppointmentContainer.js';

const RescheduleAppointmentRootWithUserToken = withUserToken(RescheduleAppointmentRootContainer);
const RescheduleAppointmentRootWithUserData = WithUserData(RescheduleAppointmentRootWithUserToken);
const RescheduleAppointmentRootWithMyAccountEnabled = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React.createElement(RescheduleAppointmentRootWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: true
    }));
};

export { RescheduleAppointmentRootWithMyAccountEnabled as default };
//# sourceMappingURL=RescheduleAppointmentRootWithUserToken.js.map
